export default __webpack_public_path__ + "images/fd767f139b80f51c0be1996991995ab6-mental_health.webp";